import { useEffect } from "react";

import { useCurrentStateAndParams } from "@uirouter/react";
import { useDispatch } from "react-redux";

import { markInitialFiltersReady } from "app/pages/sales-intelligence/modules/advanced-search-filtering/store/action-creators";
import { useSingleSavedSearch } from "app/pages/sales-intelligence/modules/leads-search/sub-modules/saved-search/query";
import type { SavedSearchRoutingParams } from "app/pages/sales-intelligence/modules/leads-search/sub-modules/saved-search/types";
import { setLeadsFilterValue } from "app/pages/sales-intelligence/modules/leads-search-filters/store/action-creators";

export const useSavedSearch = (): void => {
    const dispatch = useDispatch();

    const {
        params: { savedSearchId },
    } = useCurrentStateAndParams<SavedSearchRoutingParams>();

    const { data: savedSearchData, isSuccess, isError } = useSingleSavedSearch(savedSearchId);

    useEffect(() => {
        if (!savedSearchId) {
            return;
        }

        if (savedSearchData?.queryFilters) {
            dispatch(setLeadsFilterValue(savedSearchData.queryFilters));
        }

        if (isSuccess || isError) {
            dispatch(markInitialFiltersReady());
        }
    }, [dispatch, savedSearchId, savedSearchData, isSuccess, isError]);
};
